import { useDispatch } from "react-redux";
import { ThunkDispatch, ThunkAction } from "redux-thunk";
import { Action } from "redux";
import { AppState } from "../interfaces/general/App-State";

export type ThunkDispatchType = ThunkDispatch<AppState, any, Action>;
export type ThunkResult<Result> = ThunkAction<Result, AppState, undefined, Action>;

export const useThunkDispatch = (): ThunkDispatchType => useDispatch<ThunkDispatchType>();